
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HeaderLogo',
  data: () => {
    return {
      environment: process.env.VUE_APP_ENV,
    };
  },
});
